import { List, ListItem, Typography } from '@mui/material';
import IconeVotoRevogado from '@/components/IconeVotoRevogado';
import { SITUACAO_VOTO } from '@/dominio/SituacaoVoto';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';

class VotoRevogado extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            existeVotoRevogado: computed,
            tooltip: computed
        });
    }

    /**
     * @param {string} sigla
     */
    getObjMagistradoComposicaoPelaSigla(sigla) {
        if (!this.observableProps.registro?.composicao) {
            return undefined;
        }

        return this.observableProps.registro.composicao.find(
            (/** @type {Object} */ comp) => comp.magistrado.sigla === sigla
        );
    }

    get existeVotoRevogado() {
        return !!(
            this.observableProps.registro.votos &&
            this.observableProps.registro.votos.findIndex((voto) => voto.situacaoVoto === SITUACAO_VOTO.REVOGADO.id) !==
                -1
        );
    }

    get tooltip() {
        if (!this.existeVotoRevogado) {
            return null;
        }

        return (
            <>
                <Typography>Magistrados com votos revogados:</Typography>
                <List dense={true}>
                    {this.observableProps.registro.votos.map((voto) => {
                        if (voto.situacaoVoto !== SITUACAO_VOTO.REVOGADO.id) {
                            return null;
                        }

                        const magistradoComposicao = this.getObjMagistradoComposicaoPelaSigla(voto.siglaDoMagistrado);
                        const nomeMagistrado = magistradoComposicao?.magistrado?.nome;

                        return (
                            <ListItem key={voto.siglaDoMagistrado}>
                                <Typography>&bull;</Typography>
                                <Typography
                                    display={'inline'}
                                    sx={{ ml: 2 }}
                                >
                                    {`[${voto.siglaDoMagistrado}]${nomeMagistrado ? ' ' + nomeMagistrado : ''}`}
                                </Typography>
                            </ListItem>
                        );
                    })}
                </List>
            </>
        );
    }

    render() {
        if (!this.existeVotoRevogado) {
            return null;
        }

        return (
            <IconeVotoRevogado
                removerEstiloPadrao
                title={this.tooltip}
                sx={{ cursor: 'default', display: 'flex', alignItems: 'center' }}
            />
        );
    }
}

export default inject('stores')(observer(VotoRevogado));
